import Content from "./Content"
import Subtitle from "./Subtitle"
import Title from "./Title"

export const Section = {
  Content,
  Subtitle,
  Title,
}
